<!-- activity.component.html -->
<div *ngIf="saved" class="print-history-popup">
    <div class="print-history-popup-body">
      <h2 class="popup-title">Saved successfully </h2>
      <button
        (click)="saved = false"
        class="print-history-popup-close"
        aria-label="close popup"
      ></button>
    </div>
  </div>
<div class="wrapper">
    <div class="m-box">
        <h2>Activity Hours</h2>
        <button class="orange-btn"matTooltip="save changes" (click)="saveActivityHours()">Save</button>
        <div class="flex-rox-space"
            *ngFor="let day of ['sunday', 'monday', 'tuesday', 'wednesday', 'thursday', 'friday', 'saturday']">
                <h3 class="w5 rtl">{{ day }}</h3>
            <div style="display: flex; flex-direction: column; gap: 1em;">



                <div *ngFor="let hour of activityHours[day]; let i = index" style="display: flex; gap: 1em;">
                    <ng-container *ngIf="hour.status !== 'delete'">
                    <div class="l-flex l-flex-c t-field t-field-pad rtl" style="height: 2.5em;">
                        <label class="w50" style="white-space: nowrap;">שעת סיום</label>
                        <input type="time" style="white-space: nowrap;" class="t-field-text w100"
                            [(ngModel)]="activityHours[day][i].endTime" (change)="markAsUpdated(day, i)">
                    </div>
                    <div class="l-flex l-flex-c t-field t-field-pad rtl" style="height: 2.5em;">
                        <label class="w50" style="white-space: nowrap;">שעת התחלה</label>
                        <input type="time" style="white-space: nowrap;" class="t-field-text w100"
                            [(ngModel)]="activityHours[day][i].startTime" (change)="markAsUpdated(day, i)">
                    </div>
                    <img class="delete-hour"  matTooltip="Delete Hour" (click)="deleteHour(day,i)" src="../../assets/icons/minus-blue.svg" />
                </ng-container>
                </div>
                <hr style="width: 100%; opacity: 0.3;">
            </div>
            <div  style="display: flex;
            justify-content: flex-end;
            align-items: end;"  >

                <img class="add-hour" matTooltip="Add Hour" (click)="addHour(day)" src="../../assets/icons/plus-orange.svg" />
            </div>

        </div>
        
    </div>
</div>